import { parse } from 'qs';

import { isServerRendering } from 'src/app/utils/environment';

const extractUivIfPopulated = (uiv?: string | string[]): string | undefined =>
  typeof uiv === 'string' && uiv.length > 0 ? uiv : undefined;

export const getUivQueryParam = (): string | undefined => {
  if (isServerRendering()) {
    return undefined;
  }

  const parsed: { v?: string | string[]; V?: string | string[] } = parse(
    window.location.search,
    { ignoreQueryPrefix: true },
  );

  return extractUivIfPopulated(parsed.v) ?? extractUivIfPopulated(parsed.V);
};
